import React, { Component } from 'react';
import { Trans } from '@lingui/macro';
import { connect } from 'react-redux';
import { Col, Layout, Row } from 'antd';
import { Select } from 'bukku/components/DataEntry';
import WindowResizeListener from 'react-window-size-listener';
import dayjs from 'dayjs';
import AuthActions from 'bukku/redux/Auth/actions';
import UserActions from 'bukku/redux/User/actions';
import AppActions from 'bukku/redux/App/actions';
import Sidebar from '../Sidebar/Sidebar';
import Topbar from '../Topbar/Topbar';
import AppRouter from '../../routers/AppRouter/router';
import PageLoading from '../Page/Loading';
import { SubscribeBarStyled } from './SubscribeBarStyled';
import Announcement from './Announcement';
import Interceptor from 'bukku/components/Modal/Interceptors';
// import { NoConnectionModal } from '../../components/Modal/NoConnection';
import EditableActions from 'bukku/redux/EditableTable/actions';
import { getCurrent, getOpenKeys } from '../../helpers/urlSync';
import { GlobalOutlined } from '@ant-design/icons';
import { languageSwitcher } from '../../locales/i18n';
import LastVisitedPageModal from '../../components/Modal/LastVisitedPage';
import { EchoWebsocket } from '../../components/WebSocket/EchoWebsocket';
import {
    CancelledGraceMessage,
    EndedMessage,
    EndingSoonMessage,
    IncompleteMessage,
    ExpiringMessage,
    PastDueMessage,
    SubscribeMessage,
} from './AppTrans';
import {SubscriptionStatus} from "../../enums/SubscriptionStatus";
import SessionExpiredModal from '../../components/Modal/SessionExpiredModal';
// import {LightboxModal} from "../../components/LightBox/core/LightboxModal";
import AuditsDrawer from '../../components/Drawer/Audits'; // common component for Contact and Account Audit
// import { PusherWebSocket } from '../../components/WebSocket/PusherWebsocket'
import VersionUpdateBanner from "../Topbar/VersionUpdateBanner";
import { PlanType } from '../../enums/PlanType';
import SessionInactiveModalV2 from '../../components/Modal/SessionInactiveModalV2';
import ListActions from 'bukku/redux/List/actions';
import { SubscriptionCheck } from '../../components/Access/helper/subscription/SubscriptionCheck';
import { SubscriptionScopeKey } from '../../components/Access/helper/subscription/enum/SubscriptionScopeKey';
import _ from 'underscore';
import { createListManager } from '../../redux/List/helper';
import { L } from '../../redux/List/reducer';

const { Content, Footer } = Layout;
const { Option } = Select;
const { logout, validateSession, bootIntercom } = AuthActions;
const {
    toggleAll,
    shoeboxBadgeCountAdd,
    shoeboxPageCountAdd,
    universalSmartReconPageCountAdd,
    changeCurrent,
    changeOpenKeys,
    setDataExtractionChannel,
} = AppActions;
const {
    updateUserLocale,
} = UserActions;
const {
    addRoutedPath,
} = ListActions;

const { clearAllEditLine } = EditableActions;

const urlDomain = process.env.REACT_APP_URL_DOMAIN;

class App extends Component {
    listManager = createListManager([L.settings]);

    componentDidMount() {
        const {
            validateSession,
            history,
            location,
            addRoutedPath,
        } = this.props;
        const {onUpdateSidebar} = this;

        // We need to read L.settings, because some routes are blocked based on settings.
        // Eg MyInvois module requires is_myinvois_submission_enabled setting
        this.listManager.readLists();

        // Validate the login user.
        // If url is 'app.bukku.XX', consider it a generic page and no need to validate session
        if (window.location.hostname !== `app.${urlDomain}`)
            validateSession();

        // Listen change of URL
        history.listen(location => {
            onUpdateSidebar(location);
            console.log('qq aaaa route change', location);
            addRoutedPath(location.pathname);
        });
        onUpdateSidebar(location);
        window.addEventListener('beforeunload', this.componentCleanup);
    }

    componentDidUpdate(prevProps) {
        const {
            sessionReady,
        } = this.props;

        // For app load without session ready.
        if (sessionReady && sessionReady !== prevProps.sessionReady)
            this.onAppLoad();
    }

    componentWillUnmount() {
        const { websocket } = this.props;
        window.removeEventListener('beforeunload', this.componentCleanup);
        websocket?.leaveChannel('data_extraction');
    }

    componentCleanup = () => {
        localStorage.removeItem('low-cashflow-alert-dismissed-once');
        localStorage.removeItem('financing-portal-alert-dismissed-once');
    };

    onUpdateSidebar = () => {
        const {
            changeCurrent,
            changeOpenKeys,
        } = this.props;

        const current = getCurrent();
        const openKeys = getOpenKeys();

        changeCurrent(current);
        changeOpenKeys(openKeys);
    };

    onAppLoad = () => {
        const {
            subscription,
            user,
            company,
            shoeboxBadgeCountAdd,
            shoeboxPageCountAdd,
            universalSmartReconPageCountAdd,
            setDataExtractionChannel,
            history,
            planInUse,
            bootIntercom,
        } = this.props;

        const hasLiveChatSubscription = SubscriptionCheck
            .withKeys(SubscriptionScopeKey.LIVE_CHAT).hasSubscriptionTo();

        if (user.status === 'inactive') {
            history.push('/activate');
            return false;
        }

        // Initialize (Websocket)
        // const websocket = new PusherWebSocket();
        const websocket = new EchoWebsocket();

        // Subscribe (Shoebox)
        // websocket
        //     .channel('unshoebox')
        //     .listen('.receipt.processed', data => {
        //         shoeboxBadgeCountAdd();
        //     });

        // const channel = websocket.channel('shoebox');
        // setDataExtractionChannel(channel);

        // Subscribe (Data Extraction)
        const channel = websocket.channel('data_extraction');
        setDataExtractionChannel(channel);

        channel.listen('.document.processed', data => {
            const { current } = this.props;
            const { page_count, type } = data.shoeboxEventData || undefined;

            if (type === "SMARTRECON") {
                universalSmartReconPageCountAdd(page_count || 0);
            }
            else if (type === "SHOEBOX") {
                shoeboxPageCountAdd(page_count || 0);

                // only add badge count when not in shoebox page, to prevent badge count showing
                // for a quick second when changing page
                if (current[0] !== '/shoebox')
                    shoeboxBadgeCountAdd();
            }
        });

        // Intercom, disallow for Zero and Launch plans (but allow for trial)
        if (
            hasLiveChatSubscription &&
            ((planInUse?.type !== PlanType.ZERO && planInUse?.type !== PlanType.LAUNCH) ||
            // planInUse?.type === 'PREMIUM' ||
            // planInUse?.type === 'GROWTH' ||
            subscription?.status === SubscriptionStatus.trial ||
            subscription?.status === SubscriptionStatus.active_trial
            )
        )
            bootIntercom({ user, company });

        return null;
    };

    showFooter = () => {
        const {
            location,
        } = this.props;

        if (location.pathname === '/shoebox' || location.pathname === '/bukku-ai')
            return false;
        return true;
    };

    // For self billing
    renderSelfBillingSubscriptionStatus = () => {
        const {
            access,
            subscription,
        } = this.props;

        // Constants
        const endsAt = subscription.ends_at;
        const trialEndsAt = subscription.trial_ends_at;
        const isPastDue = subscription.is_past_due;
        const isIncomplete = subscription.is_incomplete;
        const manageBilling = access.manage_billing;

        // Dates
        const objToday = dayjs();
        const objEndsAt = (endsAt ? dayjs(endsAt) : null);
        const objTrialEndsAt = (trialEndsAt ? dayjs(trialEndsAt) : null);

        // No manage billing permission?
        if (!manageBilling)
            return null;

        if (isPastDue) {
            return (
                <div className="subscribe-bar orange">
                    <PastDueMessage />
                &nbsp;
                    <SubscribeMessage type="pastDue" />
                </div>
            );
        }

        if (isIncomplete) {
            const deadline = dayjs(subscription.updated_at).add(24, 'hour');
            const objToday = dayjs();

            const totalRemainingMinutes = deadline.diff(objToday, 'minutes');

            if (totalRemainingMinutes <= 0) // incomplete subscription should be deleted after 24 hours
                return null;

            const remainingHrs = Math.floor(totalRemainingMinutes / 60);
            const remainingMins = totalRemainingMinutes % 60;

            return (
                <div className="subscribe-bar orange">
                    <IncompleteMessage />
                &nbsp;
                    <SubscribeMessage
                        type="incomplete"
                        time={{
                            hrs: remainingHrs,
                            mins: remainingMins,
                        }}
                    />
                </div>
            );
        }

        switch (subscription?.status) {
            case SubscriptionStatus.trial: {
                const trialDaysLeft = objTrialEndsAt.diff(objToday, 'days');

                // 15 - 30 days
                if (trialDaysLeft > 15 && trialDaysLeft <= 30) {
                    return (
                        <div className="subscribe-bar">
                            <EndingSoonMessage trialDaysLeft={trialDaysLeft} />
                            &nbsp;
                            <SubscribeMessage type="green" />
                        </div>
                    );
                }
                // Within 14 days
                if (trialDaysLeft <= 14) {
                    return (
                        <div className="subscribe-bar orange">
                            <EndingSoonMessage trialDaysLeft={trialDaysLeft} />
                            &nbsp;
                            <SubscribeMessage type="orange" />
                        </div>
                    );
                }

                // Hide beyond 30 days
                return null;
            }
            case SubscriptionStatus.trial_ended: {
                const trialEndedDaysAgo = objToday.diff(objTrialEndsAt, 'days');

                return (
                    <div className="subscribe-bar red">
                        <EndedMessage days={trialEndedDaysAgo} isFreeTrial />
                        &nbsp;
                        <SubscribeMessage type="red" />
                    </div>
                );
            }
            case SubscriptionStatus.grace_period: {
                const daysLeft = objEndsAt.diff(objToday, 'days');

                if (daysLeft <= 30) {
                    return (
                        <div className="subscribe-bar orange">
                            <CancelledGraceMessage daysLeft={daysLeft} />
                            &nbsp;
                            <SubscribeMessage type="grace" />
                        </div>
                    );
                }

                return null;
            }
            case SubscriptionStatus.active: {
                // only for Manual Billing
                const isManualBilling = subscription.billing_method === 'manual';
                const isCountingDown = objEndsAt && objEndsAt.isAfter(objToday);
                const daysLeft = objEndsAt ? objEndsAt.diff(objToday, 'days') : null;

                if (isManualBilling && isCountingDown && daysLeft <= 30) {
                    return (
                        <div className="subscribe-bar orange">
                            <ExpiringMessage daysLeft={daysLeft} />
                        </div>
                    );
                }

                return null;
            }
            case SubscriptionStatus.ended: {
                const endedDaysAgo = objToday.diff(objEndsAt, 'days');

                return (
                    <div className="subscribe-bar red">
                        <EndedMessage days={endedDaysAgo} isFreeTrial={false} />
                        &nbsp;
                        <SubscribeMessage type="red" />
                    </div>
                );
            }
            default:
                return null;
        }
    };

    renderPartnerBillingSubscriptionStatus = () => {
        const {
            subscription,
        } = this.props;

        if (subscription?.status === SubscriptionStatus.ended) {
            return (
                <div className="subscribe-bar red">
                    <Trans>
                        Your subscription is not active.&nbsp;
                        Please contact our partner to reactivate the subscription.
                    </Trans>
                </div>
            );
        }
        return null;
    };

    renderSubscribeBar = () => {
        const {
            company,
            subscription,
            location,
        } = this.props;

        if (!subscription || location.pathname === '/shoebox')
            return null;

        if (company.billing_party === 'self')
            return this.renderSelfBillingSubscriptionStatus();
        return this.renderPartnerBillingSubscriptionStatus();
    };

    onAppClick = e => {
        const {
            hasActiveTable,
            clearAllEditLine,
        } = this.props;

        if (hasActiveTable && e?.target?.id !== 'bukkuContent')
            clearAllEditLine();
    };

    handleLanguageClick = value => {
        const { updateUserLocale } = this.props;
        updateUserLocale({locale: value});
    };

    renderLanguageOptions = () => languageSwitcher.map(lang => (
        <Option
            key={lang.key}
            value={lang.key}
            label={
                <div className="hoverable-icon">
                    <GlobalOutlined />
                    &nbsp;
                    {lang.value}
                </div>
            }
        >
            {lang.value}
        </Option>
    ));

    render() {
        const {
            sessionReady,
            settings,
            location,
            toggleAll,
            user,
        } = this.props;
        const url = location.pathname;

        if (!sessionReady) {
            return (
                <>
                    <PageLoading />
                    <SessionExpiredModal />
                </>
            );
        }

        if (_.isEmpty(settings))
            return <PageLoading showLoading />;

        const thisYear = dayjs().format("YYYY");
        return (
            <div onClick={this.onAppClick}>
                <Layout>
                    {/* <NoConnectionModal /> */}
                    <WindowResizeListener
                        onResize={windowSize => toggleAll(windowSize.windowWidth)}
                    />
                    <LastVisitedPageModal />
                    <SessionInactiveModalV2 />
                    <SessionExpiredModal />
                    <AuditsDrawer />
                    <Interceptor />
                    <Topbar url={url} />
                    <Layout style={{ flexDirection: 'row' }}>
                        <Sidebar url={url} />
                        <Layout id="bkMainOuterLayout" className="isoContentMainOuterLayout">
                            <Layout id="bkMainLayout" className="isoContentMainLayout">
                                {/* Version Update Banner must be inside bkMainLayout to not interfere with <Anchor /> functionality */}
                                <VersionUpdateBanner />
                                <Content id="bukkuContent" className="isomorphicContent">
                                    <SubscribeBarStyled>
                                        {this.renderSubscribeBar()}
                                    </SubscribeBarStyled>
                                    <AppRouter url={url} />
                                </Content>
                                <Footer style={this.showFooter() ? {} : { display: 'none' }}>
                                    <Row gutter={[12, 12]}>
                                        <Col span={24}>
                                            <Select
                                                showArrow={false}
                                                value={user.locale}
                                                bordered={false}
                                                dropdownStyle={{width: 160}}
                                                dropdownMatchSelectWidth={false}
                                                optionLabelProp="label"
                                                onSelect={this.handleLanguageClick}
                                            >
                                                {this.renderLanguageOptions()}
                                            </Select>
                                        </Col>
                                        <Col span={24}>
                                            <div>
                                                &copy; 2019 -
                                                {thisYear}
                                                &nbsp;
                                                Nukleus Ventures Sdn Bhd.
                                            </div>
                                        </Col>
                                    </Row>
                                </Footer>
                            </Layout>
                        </Layout>
                    </Layout>
                    <Announcement />
                </Layout>
            </div>
        );
    }
}
export default connect(state => ({
    current: state.App.current,
    locale: state.App.locale,
    websocket: state.App.websocket,
    subscription: state.Auth.subscription,
    access: state.Auth.access,
    subdomain: state.Auth.subdomain,
    user: state.Auth.user,
    company: state.Auth.company,
    accessToken: state.Auth.accessToken,
    sessionReady: state.Auth.sessionReady,
    selectedTheme: state.ThemeSwitcher.changeThemes.themeName,
    hasActiveTable: state.Editable.hasActiveTable,
    planInUse: state.Subscription.planInUse,
    settings: state.List.settings,
}), {
    logout,
    validateSession,
    bootIntercom,
    toggleAll,
    shoeboxPageCountAdd,
    shoeboxBadgeCountAdd,
    universalSmartReconPageCountAdd,
    setDataExtractionChannel,
    changeCurrent,
    changeOpenKeys,
    clearAllEditLine,
    updateUserLocale,
    addRoutedPath,
})(App);
